module.exports = __webpack_public_path__ + "static/img/286_TO8_2438_og.539e1da.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/286_TO8_2438_og.jpg
// module id = 6XXx
// module chunks = 0